import { defineStore } from 'pinia'
import router from '../router'  // ← import direct

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: JSON.parse(sessionStorage.getItem('user')) || null,
        token: sessionStorage.getItem('token') || null
    }),
    actions: {
        setUser(user, token) {
            this.user = user
            this.token = token
            sessionStorage.setItem('user', JSON.stringify(user))
            sessionStorage.setItem('token', token)
        },
        logout() {
            this.user = null
            this.token = null
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('token')
            router.push({ path: '/login' })
        }
    },
    getters: {
        isAuthenticated: (state) => !!state.token
    }
})